import React from "react";
import "./ResourceMaturityBadge.scss";

export const RESOURCE_MATURITY = Object.freeze({
  None: 0,
  Alpha: 1,
  Beta: 2,
  Future: 3
});

const maturityByValue = {
  1: {
    label: "Alpha",
    description: "In development"
  },
  2: {
    label: "Beta",
    description: "Development and development testing are complete; QA is not complete"
  },
  3: {
    label: "Future",
    description: "Deferred future Resource"
  }
};

export const normalizeResourceMaturity = (value) => {
  if (value === null || value === undefined || value === "") return RESOURCE_MATURITY.None;
  if (typeof value === "number") return Number.isFinite(value) ? value : RESOURCE_MATURITY.None;

  const normalized = String(value).trim().toLowerCase();
  if (normalized === "alpha") return RESOURCE_MATURITY.Alpha;
  if (normalized === "beta") return RESOURCE_MATURITY.Beta;
  if (normalized === "future") return RESOURCE_MATURITY.Future;
  if (normalized === "none" || normalized === "no tag" || normalized === "production") return RESOURCE_MATURITY.None;

  const parsed = Number(normalized);
  return Number.isFinite(parsed) ? parsed : RESOURCE_MATURITY.None;
};

const ResourceMaturityBadge = ({ value, className = "" }) => {
  const maturity = normalizeResourceMaturity(value);
  const definition = maturityByValue[maturity];
  if (!definition) return null;

  return (
    <span
      className={`resource-maturity-badge resource-maturity-badge--${definition.label.toLowerCase()}${className ? ` ${className}` : ""}`}
      title={`${definition.label}: ${definition.description}`}
      aria-label={`${definition.label} Resource: ${definition.description}`}
    >
      {definition.label}
    </span>
  );
};

export default ResourceMaturityBadge;
